import { AccountCircle } from "@mui/icons-material";
import { AppBar, Button, Toolbar, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useContext, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link, useNavigate } from "react-router-dom";
import useStyles from "./styles";
import axios from "axios";
import { toast } from "react-toastify";
import { MyContext } from "../ContextApi";
import { logoutUser } from "../../services/transactions";

const isAuthenticated = true;

const NarBar = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { getDecryptedSessionItem } = useContext(MyContext);
  

  const navigate = useNavigate();

  const onStopSession = () => {
    if (
      getDecryptedSessionItem("session_id") === null ||
      getDecryptedSessionItem("session_id") === undefined ||
      getDecryptedSessionItem("session_id") === ""
    ) {
      return;
    }

    // const url = `${sessionStorage["server"]}/scan/stop-session`;
    const url = `${getDecryptedSessionItem("server")}/scan/stop-session`;

    axios
      .post(
        url,
        { sessionId: getDecryptedSessionItem("session_id") },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result["status"] === "success") {
          toast.success("successfully stopped session");
          sessionStorage.removeItem("request_id");
          sessionStorage.removeItem("session_id");
          //  navigate("/export-reports");
        } else {
          toast.error(result["error"]);
        }
      });
  };

  const logout = () => {
    confirmAlert({
      title: "Confirmation",
      message:
        "Are you sure you want to logout ? This action will clear your current queue containing pending changes.",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            

            await logoutUser({
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            });
            
            await onStopSession();
            // remove the session storage items
            // sessionStorage.removeItem("username");
            // sessionStorage.removeItem("name");
            // sessionStorage.removeItem("token");
            // sessionStorage.removeItem("email");
            // sessionStorage.removeItem("reportType");
            // sessionStorage.removeItem("clientId");
            // sessionStorage.removeItem("server");
            // sessionStorage.removeItem("installationId");
            sessionStorage.clear();
            localStorage.clear();
            navigate("/");
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <>
      <AppBar position="fixed">
        <Toolbar className={classes.toolbar}>
          {/* <IconButton onClick={() => {}} color='inherit' sx={{ ml: 1 }}>
            {theme.palette.mode == 'dark' ? <Brightness7 /> : <Brightness4 />}
          </IconButton> */}
          <div>
            <Button
              component={Link}
              to={"/current-scans"}
              color="inherit"
              className={classes.linkButton}
              onClick={() => {}}
            >
              Home
            </Button>
            <Button
              component={Link}
              to={"/export-reports"}
              color="inherit"
              className={classes.linkButton}
              onClick={() => {}}
            >
              Report
            </Button>
            <Button
              component={Link}
              to={"/compare-files"}
              color="inherit"
              className={classes.linkButton}
              onClick={() => {}}
            >
              Compare Files
            </Button>
            <Button
              component={Link}
              to={"/uploads"}
              color="inherit"
              className={classes.linkButton}
              onClick={() => {}}
            >
              Uploads
            </Button>
            <Button
              component={Link}
              to={"/daily-usage"}
              color="inherit"
              className={classes.linkButton}
              onClick={() => {}}
            >
              Daily Usage
            </Button>
          </div>

          <div>
            {!isAuthenticated ? (
              <Button color="inherit" onClick={() => {}}>
                Login &nbsp;
                <AccountCircle />
              </Button>
            ) : (
              <>
                <Button
                  component={Link}
                  to={"/profile/:id"}
                  color="inherit"
                  className={classes.linkButton}
                  onClick={() => {}}
                >
                  {!isMobile && <> {sessionStorage["name"]} </>}
                </Button>
                <Button
                  color="inherit"
                  className={classes.linkButton}
                  onClick={logout}
                >
                  Logout
                </Button>
              </>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default NarBar;
